import { getProject } from '@theatre/core'

export default class Studio {
	static defaults = {
		enabled: true,
		project: 'Restart',
		sheet: 'Main',
		state: null,
		param: 'theatre',
		storageKey: 'theatre:open',
		shortcut: { code: 'KeyT', altKey: true },
	}

	constructor(options = {}) {
		if (Studio.instance) return Studio.instance

		this.options = { ...Studio.defaults, ...options }
		this.isOpen = false
		this.studio = null
		this.#build()

		Studio.instance = this
	}

	#build() {
		const { project, sheet, state } = this.options

		this.project = getProject(project, state ? { state } : undefined)
		this.sheet = this.project.sheet(sheet)
	}

	async init() {
		if (!__STUDIO__ || !this.options.enabled) return

		this.#bindShortcut()

		if (this.#resolvePreference()) await this.open()
	}

	#resolvePreference() {
		const { param, storageKey } = this.options
		const value = new URLSearchParams(window.location.search).get(param)

		if (value === null) return localStorage.getItem(storageKey) === '1'

		const open = value !== '0' && value !== 'false'
		localStorage.setItem(storageKey, open ? '1' : '0')

		return open
	}

	#bindShortcut() {
		const { code, altKey } = this.options.shortcut

		this._onKeyDown = event => {
			if (event.code !== code || event.altKey !== altKey) return

			event.preventDefault()
			this.toggle()
		}

		window.addEventListener('keydown', this._onKeyDown)
	}

	async #load() {
		if (__STUDIO__) {
			const imported = await import('@theatre/studio')

			return imported.default?.default ?? imported.default ?? imported
		}

		return null
	}

	async open() {
		if (this.studio) {
			this.studio.ui.restore()
		} else {
			this.studio = await this.#load()
			this.studio?.initialize()
		}

		this.isOpen = !!this.studio
		this.#persist()
	}

	close() {
		this.studio?.ui.hide()
		this.isOpen = false
		this.#persist()
	}

	toggle() {
		return this.isOpen ? this.close() : this.open()
	}

	#persist() {
		localStorage.setItem(this.options.storageKey, this.isOpen ? '1' : '0')
	}

	dispose() {
		window.removeEventListener('keydown', this._onKeyDown)
		Studio.instance = null
	}
}
